import React from 'react';
import { CardContent, SxProps, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { useTranslation } from 'react-i18next';

export function ArchivedCurrencyTooltip({ className, sx }: { className?: string; sx?: SxProps }) {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t('burning-rules.archived-currency.tooltip')}
      className={className}
      sx={sx}
      placement="right"
    >
      <CardContent>
        <FontAwesomeIcon icon={faExclamationTriangle} color="grey" />
      </CardContent>
    </Tooltip>
  );
}
